import React from "react";

/**
 * Diagrama de Visión Integrada con identidad Salud y Visión.
 * SVG nativo con paleta sage + tipografía manuscrita.
 */
const VisionDiagram = () => (
  <svg
    viewBox="0 0 540 540"
    className="w-full h-auto"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="vision-diagram"
    aria-label="Diagrama de la visión integrada: Antigravedad, Lenguaje-Audición, Centrado e Identificación"
  >
    <defs>
      {/* Degradados — gama verde seco suave y luminosa, estilo acuarela */}
      <radialGradient id="gradAnti" cx="50%" cy="50%" r="50%">
        {/* Sage crema muy suave */}
        <stop offset="0%" stopColor="#d8dfc6" stopOpacity="0.75" />
        <stop offset="100%" stopColor="#bfcaa4" stopOpacity="0.5" />
      </radialGradient>
      <radialGradient id="gradLeng" cx="50%" cy="50%" r="50%">
        {/* Sage oliva muy claro con matiz dorado */}
        <stop offset="0%" stopColor="#e0d99a" stopOpacity="0.75" />
        <stop offset="100%" stopColor="#c6c080" stopOpacity="0.5" />
      </radialGradient>
      <radialGradient id="gradCent" cx="50%" cy="50%" r="50%">
        {/* Sage medio luminoso */}
        <stop offset="0%" stopColor="#b0bf8a" stopOpacity="0.75" />
        <stop offset="100%" stopColor="#8ea067" stopOpacity="0.5" />
      </radialGradient>
      <radialGradient id="gradIden" cx="50%" cy="50%" r="50%">
        {/* Sage verde-menta suave, con un matiz distinto para diferenciarse */}
        <stop offset="0%" stopColor="#9db8a0" stopOpacity="0.75" />
        <stop offset="100%" stopColor="#7a987e" stopOpacity="0.5" />
      </radialGradient>

      {/* Filtro suave tipo acuarela */}
      <filter id="soft" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur stdDeviation="0.6" />
      </filter>
    </defs>

    {/* Decoración — estrellitas de fondo */}
    <text x="30" y="40" fontFamily="serif" fontSize="26" fill="#e8e3d0" opacity="0.7">✦</text>
    <text x="490" y="55" fontFamily="serif" fontSize="18" fill="#e8e3d0" opacity="0.7">✧</text>
    <text x="50" y="510" fontFamily="serif" fontSize="20" fill="#e8e3d0" opacity="0.7">✦</text>
    <text x="500" y="500" fontFamily="serif" fontSize="22" fill="#e8e3d0" opacity="0.7">✦</text>

    {/* 4 círculos solapados (Diagrama de Venn) con blend multiply para que los solapamientos se vean */}
    <g style={{ mixBlendMode: "multiply" }} filter="url(#soft)">
      {/* Arriba-izquierda · Antigravedad */}
      <circle cx="200" cy="200" r="150" fill="url(#gradAnti)" />
      {/* Arriba-derecha · Lenguaje-Audición */}
      <circle cx="340" cy="200" r="150" fill="url(#gradLeng)" />
      {/* Abajo-izquierda · Centrado */}
      <circle cx="200" cy="340" r="150" fill="url(#gradCent)" />
      {/* Abajo-derecha · Identificación */}
      <circle cx="340" cy="340" r="150" fill="url(#gradIden)" />
    </g>

    {/* Etiqueta central: VISIÓN — círculo grande destacado */}
    <g>
      {/* Halo suave */}
      <circle cx="270" cy="270" r="72" fill="#faf7ee" opacity="0.6" />
      {/* Círculo principal con doble borde */}
      <circle cx="270" cy="270" r="62" fill="#faf7ee" stroke="#5a6b3c" strokeWidth="2.5" />
      <circle cx="270" cy="270" r="56" fill="none" stroke="#a9a55a" strokeWidth="1" strokeDasharray="2 3" opacity="0.7" />
      {/* Texto manuscrito */}
      <text
        x="270"
        y="272"
        textAnchor="middle"
        fontFamily="'Pinyon Script', 'Caveat', cursive"
        fontSize="48"
        fill="#364220"
      >
        Visión
      </text>
      {/* Estrella decorativa debajo */}
      <text x="270" y="298" textAnchor="middle" fontSize="14" fontFamily="serif" fill="#7d8e5a">✦</text>
    </g>

    {/* Etiquetas de cada círculo */}
    {/* Antigravedad */}
    <g>
      <text x="135" y="135" textAnchor="middle" fontFamily="'Pinyon Script', cursive" fontSize="28" fill="#364220">
        Antigravedad
      </text>
      <text
        x="135"
        y="160"
        textAnchor="middle"
        fontFamily="Inter, system-ui, sans-serif"
        fontSize="12"
        fontStyle="italic"
        fill="#556e43"
        style={{ letterSpacing: "0.05em" }}
      >
        ¿Dónde estoy?
      </text>
    </g>

    {/* Lenguaje-Audición */}
    <g>
      <text x="405" y="135" textAnchor="middle" fontFamily="'Pinyon Script', cursive" fontSize="26" fill="#364220">
        Lenguaje
      </text>
      <text x="405" y="160" textAnchor="middle" fontFamily="'Pinyon Script', cursive" fontSize="20" fill="#364220">
        y audición
      </text>
    </g>

    {/* Centrado */}
    <g>
      <text x="135" y="410" textAnchor="middle" fontFamily="'Pinyon Script', cursive" fontSize="28" fill="#364220">
        Centrado
      </text>
      <text
        x="135"
        y="435"
        textAnchor="middle"
        fontFamily="Inter, system-ui, sans-serif"
        fontSize="12"
        fontStyle="italic"
        fill="#556e43"
        style={{ letterSpacing: "0.05em" }}
      >
        ¿Dónde está?
      </text>
    </g>

    {/* Identificación */}
    <g>
      <text x="405" y="410" textAnchor="middle" fontFamily="'Pinyon Script', cursive" fontSize="28" fill="#364220">
        Identificación
      </text>
      <text
        x="405"
        y="435"
        textAnchor="middle"
        fontFamily="Inter, system-ui, sans-serif"
        fontSize="12"
        fontStyle="italic"
        fill="#556e43"
        style={{ letterSpacing: "0.05em" }}
      >
        ¿Qué es?
      </text>
    </g>
  </svg>
);

export default VisionDiagram;
